<script>
    import Inputmask from "inputmask";
    import {VTextField} from 'vuetify/lib';

    export default {
        name: 'VDateField',
        extends: VTextField,
        mounted() {
            const input = this.$el.querySelector('input')
            if (input) {
                Inputmask("9999-99-99", {
                    rightAlign: false,
                    placeholder: "aaaa-ll-zz"
                }).mask(input);
            }
        }
    }
</script>
